export const _punctuation = '!"#$%&\'+\\-.,/:;<=>?@\\[\\]`^{|}~'
